import Http from '@/api/http.js'

export default {

  index(filters){
    return Http.get(`/financial/payment_resume`, {params: {...filters}})
  },

  show(id, filters) {
    return Http.get(`/financial/payment_resume/${id}`, {params: {...filters}});
  },
}